<template>
  <div>
    <!-- 顶部面包屑 -->
    <breadcrumbs></breadcrumbs>

    <!-- 表单查询 -->
    <el-form :inline="true" ref="form" :model="form" label-width="80px">
      <el-form-item label="员工姓名">
        <el-input
          v-model="form.name"
          placeholder="请输入员工姓名"
          clearable
          style="width: 200px"
        ></el-input>
      </el-form-item>
      <el-form-item label="员工电话">
        <el-input
          v-model="form.phone"
          placeholder="请输入员工电话"
          clearable
          style="width: 200px"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList()">查询</el-button>
        <el-button @click="resetForm()">重置</el-button>
      </el-form-item>
    </el-form>

    <!-- 温馨提示 -->
    <div class="tip-container">
      <i class="el-icon-warning" style="color: var(--warning); margin-right: 5px"></i>
      <span style="color: var(--warning)">温馨提示：</span>
      <span style="color: var(--text-muted)">数据来源于社区售水机+楼宇机。</span>
    </div>

    <!-- 表格 -->
    <el-table
      :data="tableData"
      border
      stripe
      style="width: 100%; margin-top: 15px"
      v-loading="loading"
    >
      <el-table-column prop="index" label="序号" width="60" align="center">
        <template slot-scope="scope">
          {{ (currentPage - 1) * pageSize + scope.$index + 1 }}
        </template>
      </el-table-column>

      <el-table-column
        prop="name"
        label="员工姓名"
        min-width="100"
        align="center"
      ></el-table-column>

      <el-table-column
        prop="phone"
        label="员工电话"
        min-width="120"
        align="center"
      ></el-table-column>

      <el-table-column
        prop="userPackagePrice"
        label="用户套餐实付(元)"
        min-width="120"
        align="center"
      >
        <template slot-scope="scope">
          <div class="amount-container">
            <span class="amount-text">{{ scope.row.userPackagePrice }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        prop="activityPackagePrice"
        label="活动套餐实付(元)"
        min-width="120"
        align="center"
      >
        <template slot-scope="scope">
          <span class="amount-text">{{ scope.row.activityPackagePrice }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="totalPrice"
        label="套餐总实付(元)"
        min-width="120"
        align="center"
      >
        <template slot-scope="scope">
          <div class="amount-container">
            <span class="amount-text">{{ scope.row.totalPrice }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        prop="refundPrice"
        label="退款金额(元)"
        min-width="100"
        align="center"
      >
        <template slot-scope="scope">
          <span class="amount-text">{{ scope.row.refundPrice }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="salaryTotal"
        label="实际销售(元)"
        min-width="100"
        align="center"
      >
        <template slot-scope="scope">
          <span class="amount-text salary-text">{{
            scope.row.totalPrice - scope.row.refundPrice
          }}</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="100" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="text"
            style="color: var(--accent)"
            @click="handleDetail(scope.row)"
          >
            详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="prev, pager, next, sizes, total"
      :total="total"
      style="text-align: center; margin-top: 20px"
    >
    </el-pagination>

    <!-- 详情弹窗 -->
    <el-dialog
      title="员工工资详情"
      :visible.sync="detailDialogVisible"
      width="60%"
      :close-on-click-modal="false"
    >
      <div v-if="currentDetail">
        <el-descriptions :column="2" border>
          <el-descriptions-item label="员工姓名">{{
            currentDetail.name
          }}</el-descriptions-item>
          <el-descriptions-item label="员工电话">{{
            currentDetail.phone
          }}</el-descriptions-item>
          <el-descriptions-item label="用户支付统计"
            >{{ currentDetail.userPaymentTotal }}元</el-descriptions-item
          >
          <el-descriptions-item label="活动套装统计"
            >{{ currentDetail.activityTotal }}元</el-descriptions-item
          >
          <el-descriptions-item label="套装总统计"
            >{{ currentDetail.packageTotal }}元</el-descriptions-item
          >
          <el-descriptions-item label="速配金额"
            >{{ currentDetail.speedTotal }}元</el-descriptions-item
          >
          <el-descriptions-item label="实际薪资">
            <span class="salary-highlight"
              >{{ currentDetail.salaryTotal }}元</span
            >
          </el-descriptions-item>
          <el-descriptions-item label="统计时间">{{
            currentDetail.createTime || "2024-01-01"
          }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import btns from "@/components/btns.vue";
import { handleConfirm, handleAlert } from "../../components/UtilsIf";

export default {
  components: {
    breadcrumbs,
    btns,
  },
  data() {
    return {
      loading: false,
      form: {
        name: "",
        phone: "",
      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      detailDialogVisible: false,
      currentDetail: null,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 获取列表数据
    getList() {
      this.loading = true;
      // 模拟API调用
      setTimeout(() => {
        // 这里替换为实际的API调用
        this.$api.marketing.performance_list(this.form).then((res) => {
          this.tableData = res.data.rows;
          this.total = res.data.total;
          this.loading = false;
        });
      }, 500);
    },

    // 重置表单
    resetForm() {
      this.form = {
        name: "",
        phone: "",
      };
      this.currentPage = 1;
      this.getList();
    },

    // 查看详情
    handleDetail(row) {
      // this.currentDetail = { ...row };
      // this.detailDialogVisible = true;
      this.$router.push({
        path: "/staff/sellTeam/teamDetail1info",
        query: { data: JSON.stringify(row)  },
      });
    },

    // 分页大小改变
    handleSizeChange(newSize) {
      this.pageSize = newSize;
      this.currentPage = 1;
      this.getList();
    },

    // 当前页改变
    handleCurrentChange(newPage) {
      this.currentPage = newPage;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.tip-container {
  background-color: var(--input-bg);
  border: 1px solid var(--warning);
  border-radius: 4px;
  padding: 8px 12px;
  margin-top: 10px;
  font-size: 14px;
  line-height: 1.5;
}

.amount-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.amount-text {
  font-weight: 500;
  color: var(--text-sub);
}

.salary-text {
  color: var(--accent);
  font-weight: 600;
}

.amount-badge {
  display: inline-block;
  min-width: 16px;
  height: 16px;
  line-height: 16px;
  text-align: center;
  border-radius: 8px;
  font-size: 11px;
  color: white;
  font-weight: bold;
  cursor: pointer;
}

.badge-yellow {
  background-color: var(--warning);
}

.salary-highlight {
  color: var(--accent);
  font-weight: 600;
  font-size: 16px;
}

// 表格样式优化
::v-deep .el-table {
  .el-table__header {
    th {
      background-color: var(--table-header-bg);
      color: var(--table-header-text);
      font-weight: 600;
    }
  }

  .el-table__body {
    tr:hover {
      background-color: var(--table-row-hover);
    }
  }
}

// 分页样式
::v-deep .el-pagination {
  .el-pager li.active {
    background-color: var(--accent);
    color: white;
  }
}

// 表单样式
::v-deep .el-form {
  background-color: var(--card-bg);
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 15px;
}
</style>
